export const defaultFilters = {
  pagination: {
    limit: -1,
  },
}
